import React from "react";
import { useDispatch } from "react-redux";
import { i18n } from '../../translate/i18n';
import {
  Paper, Table, TableBody, TableRow, TableCell, Typography, IconButton,
} from '@mui/material';
import EnhancedTableHead from "../../UI/MaterialTableOverrides/EnhancedTableHead";
import { SaveAlt } from '@mui/icons-material';
import pptIcon from '../../assets/ms-powerpoint.png';
import youtubeIcon from '../../assets/youtube-logo-5-2.png';

export default function TableColaboradores(props) {

  const headRows = [
    { id: "name", numeric: false, disablePadding: false, label: i18n.t('headRows.file') },
    { id: "modifiedAt", numeric: false, disablePadding: false, label: i18n.t('headRows.modifiedAt') },
    { id: "size", numeric: false, disablePadding: false, label: i18n.t('headRows.size') },
    { id: "download", numeric: false, disablePadding: false, label: i18n.t('headRows.download') },
    { id: "description", numeric: false, disablePadding: false, label: i18n.t('headRows.description') },
  ];

  const files = [
    { _id: 0, type: 'file-pdf', name: 'elgin_tutorial.pdf', size: '4.2 MB', modifiedAt: '29/09/2021', url: 'https://documentos-comuns-publicos.s3.sa-east-1.amazonaws.com/geequip/support_files/elgin_tutorial.pdf', description: i18n.t('files.description') },
    { _id: 1, type: 'link-youtube', name: 'Treinamento Web', size: '-', modifiedAt: '24/11/2021', url: 'https://www.youtube.com/playlist?list=PLE0fhnznACOwmrrVV9V9D929DPZObNUT9', description: i18n.t('files.trainmentWeb') },
    { _id: 2, type: 'link-youtube', name: 'Treinamento App', size: '-', modifiedAt: '24/11/2021', url: 'https://www.youtube.com/playlist?list=PLE0fhnznACOzwdmmznRB-3W96EKZYBHnH', description: i18n.t('files.trainmentApp') },
  ]

  const styles = {
    table: {
      position: 'relative',
    },
    opacityContainer: {
    },
    tableRow: {
      cursor: 'pointer'
    },
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      height: '100px',
    },
    deleteTextConfirm: {
      marginLeft: '-30px',
      fontWeight: 'bold',
    },
    editWidth: {
      width: '90%'
    },
    avatarContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    avatar: {
      width: 50,
      height: 50,
    },
    avatarSmallText: {
      fontSize: 12,
      width: 50,
      height: 50,
    },
    chip: {
      margin: 5,
    },
    thumbUp: {
      marginRight: 15,
      color: "#349c34"
    },
    thumbDown: {
      marginRight: 15,
      color: "#d04545"
    },
    statusContainer: {
      display: 'flex',
      alignItems: 'center',
    },
  }

  return (
    <Paper style={{marginBottom: 40}}>
      <Typography variant='h6' style={{ padding: 20 }}>{i18n.t('filesTypography.label')}</Typography>
      <Table style={styles.table}>
        <EnhancedTableHead
          style={styles.opacityContainer}
          headRows={headRows}
          order={'asc'}
          orderBy={'file'}
          onRequestSort={() => { }}
        />
        <TableBody style={styles.opacityContainer}>
          {files.map((file, index) => {
            return (
              <TableRow
                style={styles.tableRow}
                key={file._id}
                hover
                onClick={() => window.open(file.url)}
              >
                <TableCell>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    { file.type === 'file-pdf' && <img src={pptIcon} style={{ width: 25, marginRight: 10 }} /> }
                    { file.type === 'link-youtube' && <img src={youtubeIcon} style={{ width: 25, marginRight: 10 }} /> }
                    { file.name }
                  </div>
                </TableCell>
                <TableCell>{file.modifiedAt}</TableCell>
                <TableCell>{file.size}</TableCell>
                <TableCell>
                  <IconButton size="large">
                    <SaveAlt />
                  </IconButton>
                </TableCell>
                <TableCell>{file.description}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );

}



